<template>
  <div class="view-footer-home">
    <span class="shared-link-footer-logo-wrh"/>

    <span class="shared-link-footer-link-wrh">
      <a
        class="hide-on-small-screen"
        target="_blank"
        :title="$t('shared-link.footer.link.install', {brandName: getAtiBrandName})"
        :href="$t('wrh.shared-link.link.install-atih')" >
        {{ $t('shared-link.footer.link.install', {brandName: getAtiBrandName}) }}
      </a>

      <span
        class="hide-on-small-screen"
        style="margin-left: 64px; color: #9a9fa9;">
        {{ $t('shared-link.footer.link.mobile', {brandName: getAtiBrandName}) }}
      </span>

      <a
        style="margin-left: 26px;"
        target="_blank"
        :title="$t('shared-link.footer.link.android')"
        :href="$t('wrh.shared-link.link.install-atih.android')" >
        {{ $t('shared-link.footer.link.android') }}
      </a>

      <a
        style="margin-left: 26px;"
        target="_blank"
        :title="$t('shared-link.footer.link.ios')"
        :href="$t('wrh.shared-link.link.install-atih.ios')" >
        {{ $t('shared-link.footer.link.ios') }}
      </a>

    </span>
  </div>
</template>

<style lang="scss" scoped>
  @media screen and (min-width: 0px) and (max-width: 900px) {
    .hide-on-small-screen{ display: none; }
  }

  .shared-link-footer-logo-wrh {
    display: inline-block;
    text-align: left;
    background: url('../assets/logo/wrh-short-logo.png') no-repeat;
    width: 32px;
    height: 32px;
    margin: 16px;
  }

  .shared-link-footer-link-wrh {
    position: absolute;
    display: inline-block;
    text-align: center;
    bottom: 0;
    left: 80px;
    height: 64px;
    line-height: 64px;
    color: $av-fixed-link;
  }
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('shared-link');

export default {
  name: 'ViewFooterHome',
  computed: {
    ...mapGetters([
      'getAtiBrandName'
    ])
  }
};
</script>
